import React from 'react';
import { makeStyles } from '@mui/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TablePagination from '@mui/material/TablePagination';

import { Link } from 'react-router-dom';
import TablePaginationActions from '../../../shared/components/Table/Actions';
import Button from '@mui/material/Button';

const useStyles = makeStyles({
    table: {
        minWidth: 650,
    },
    novoRegistro: {
        marginTop: '10px',
        marginBottom: '20px',
    },
    cursorLink: {
        cursor: 'pointer'
    }
});


const LivroIntituicaoTable = ({ livrosInstituicao, handleChangePage }) => {
    const classes = useStyles();

    return (
        <div>
            <Table className={classes.table} size="small" aria-label="a dense table">
                <TableHead>
                    <TableRow>
                        <TableCell>Descrição</TableCell>
                        <TableCell>Ações</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>

                    {livrosInstituicao.content.map((li) => (
                        <TableRow key={li.codigo}>
                            <TableCell>{li.livro.descricao}</TableCell>
                            <TableCell>
                                <Button
                                    component={Link}
                                    to={{
                                        pathname: '/conteudos/' + li.livro.codLivro,
                                    }}
                                    type="button"
                                    variant="contained"
                                    color="secondary"
                                    className={classes.submit}>
                                    Abrir Livro
                                </Button>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
            <TablePagination
                rowsPerPageOptions={[]}
                rowsPerPage={livrosInstituicao.size ? livrosInstituicao.size : 0}
                component="div"
                count={livrosInstituicao.totalElements}
                page={livrosInstituicao.number}
                onPageChange={handleChangePage}
                labelDisplayedRows={({ from, to, count }) => (from + "-" + to + " de " + (count !== -1 ? count + " registros" : + " mais de " + to))}
                ActionsComponent={TablePaginationActions}
            />
        </div>
    );
}

export default LivroIntituicaoTable;